export default "__VITE_ASSET__DZIrLEGH__"